import React from "react";
import "./Common_Blog_card.css";
import { IDS } from "../../../utils/common";

const Common_Blog_Card = ({ blog, handleBlogClick }) => {

  const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        className="blog_card"
        onClick={() => handleBlogClick(blog)}
      >
        <div className="blog_img_wrapper">
          <img
            src={IDS?.IMG_URL + blog?.image}
            alt={blog?.name}
            className="blog_img"
          />
        </div>

        <div className="blog_overlay">
          <h5 className="blog_title">{blog?.name}</h5>

          <div className="blog_footer">
            <span className="blog_date">{formatDate(blog?.createdAt)}</span>

            <span
              className="blog_link"
              onClick={(e) => {
                e.stopPropagation();
                handleBlogClick(blog);
              }}
            >
              Start Reading
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Common_Blog_Card;